const doc = [({"en":({"draft":"Draft", "published":"Published"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;